// extracted by mini-css-extract-plugin
module.exports = {"Root":"Icon_Root__1PhuZ"};